export * from './reset-password-form.component';
